<template>
    <div>
        <div v-if="loaded" class="product-grid product-grid__wrapper">
            <div v-for="item in store.methods.itemsInLinje(this)" :key="item.id" class="product-grid product-grid__product" @click="store.methods.chooseProduct(item, this)" :class="[(store.state.numberOfProductsFor2xGrid.includes(numberOfFilteredItems)) ? 'product-grid__product--two-grid' : 'product-grid__product--three-grid']">
                <div class="product-grid product-grid__image-container">
                    <div class="product-grid__image-box" :class="[ store.methods.getCheckmarkClass(item, this), store.methods.getImageClass('product-grid__image-box--', this) ]">
                        <div class="product-grid__inner-image-wrapper" :class="store.methods.getImageClass('product-grid__inner-image-wrapper--', this)">
                            <img :src="store.methods.getImage(item.id, imageLayout, this)" draggable="false" class="product-grid product-grid__image" :class="store.methods.getImageClass('product-grid__image--', this)">
                        </div>
                    </div>
                </div>
                <div class="product-grid product-grid__title" :class="[(chosenProductId == item.id ) ? 'product-grid__title--active' : '']">{{item.title.rendered}}</div>
            </div>
        </div>
        <div v-if="!loaded" class="loading loading__wrapper">
        </div>
    </div>
</template>

<script>

import { inject } from 'vue';

export default {
    name: 'ProductGrid',
    setup() {
        const store = inject('store');
        return {
            store
        }
    },
    data() {
        return {
            chosenProductId: '',
            items: [],
            loaded: false,
            dummy: '',
            numberOfFilteredItems: 0
        }
    },
    props: {
        endpoint: String,
        imageLayout: String,
    },
    mounted() {
        const store = inject('store');
        this.fetchData(store);
    },
    methods: {
        async fetchData(store) {
            let fetchEndpoint = store.state.endpoint + this.endpoint;
            let items = await store.methods.fetchProductData(fetchEndpoint);
            this.items = JSON.parse(items);
            this.loaded = true;
            store.methods.setStepAsLoaded(this);
        },
        updateChosenProductCheckmark(action) {
            this.$emit('updateChosenProductCheckmark', action)
        }
    }
}
</script>
